import React, { createContext, useState, ReactNode, useContext } from 'react';
import { MessageProps, MessageType } from '../components/Message';

interface MessageContextType {
  message: MessageProps;
  setMessage: (messageProps: MessageProps) => void;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [message, setMessage] = useState<MessageProps>({ content: "", type: MessageType.SUCCESS });

  return (
    <MessageContext.Provider value={{ message, setMessage }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within MessageProvider');
  }
  return context;
};
